import React from "react";
import { Stack, IconButton } from "@mui/material";
import { FacebookShareButton, LinkedinShareButton } from "react-share";
import ShareIcon from "@mui/icons-material/Share";

const ShareButtons = ({ url, title }) => {
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      alert("Link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy link:", err);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <FacebookShareButton url={url} title={title}>
        <IconButton size="small" sx={{ padding: "0.25rem" }} aria-label="Share on Facebook">
          <img src="https://d3a0rs3velfrz.cloudfront.net/footer/facebook-Icon.webp" alt="Share on Facebook" style={{ width: 24, height: 24 }} />
        </IconButton>
      </FacebookShareButton>

      <LinkedinShareButton url={url} title={title}>
        <IconButton size="small" sx={{ padding: "0.25rem" }} aria-label="Share on LinkedIn">
          <img src="https://d3a0rs3velfrz.cloudfront.net/footer/linkedIn-Icon.webp" alt="Share on LinkedIn" style={{ width: 24, height: 24 }} />
        </IconButton>
      </LinkedinShareButton>

      <IconButton role="button" size="small" onClick={handleCopyLink} title="Copy link" aria-label={`Copy Blog Link - ${title}`}>
        <ShareIcon sx={{ width: 24, height: 24 }} />
      </IconButton>
    </Stack>
  );
};

export default ShareButtons;
